import http from '../../http'

// 获取基本字段
// 发送短信、邮件、微信营销信息插入动态变量使用
let getBasicField = (params) => {
  return http.get('activityservice/smstemplate/field', params)
}

// 获取资料或者文章的分类列表
let getFileList = (params) => {
  return http.get('content-service/doc_article/page_org?page=' + params.page + '&size=' + params.size + '&categories=' + params.categories, params)
}

// 获取资料或者文章的分类列表
let getFileListAll = (params) => {
  return http.get('content-service/doc_article_net/page?page=' + params.page + '&size=' + params.size + '&categories=' + params.categories, params)
}

// 获取下载中心列表
let getDownloadlist = (params) => {
  return http.get('opservice/ansyctask/list?pageNum=' + params.pageNum + '&pageSize=' + params.pageSize, params)
}
// 下载中心取消下载
let DownloadCancel = (id) => {
  return http.get('opservice/ansyctask/complete?id=' + id + '&state=取消&url=&error=用户取消')
}

// 获取H5页面标题
let getH5Title = (params) => {
  return http.post("opservice/h5title/get", params)
}

export default {
  getBasicField,
  getFileList,
  getFileListAll,
  getDownloadlist,
  DownloadCancel,
  getH5Title
}
